import React from 'react'

import boltsIconSrc from './bolts.svg'

import './style.css'

const MobileConfirmationStep = () => (
  <div className="setup-mobile-step">
    <h1>
      <img alt="bolts" src={boltsIconSrc} className="setup-mobile-step-bolts"/>
      To finish setting up your Drift account, go to your computer.
    </h1>
    <p>
      We just sent you an email with a link to your Drift account.
      See you soon! <span role="img" aria-label="computer">💻</span>
    </p>
  </div>
)

export default MobileConfirmationStep



// WEBPACK FOOTER //
// ./src/layouts/MobileConfirmationStep/component.js